/* Lumora freeze: pins the announcement bar and header with position:fixed + a spacer,
   so it works regardless of parent overflow rules. Flags header "data-stuck" after scrolling. */
(function () {
  'use strict';
  var state = { items: [], ro: null };
  function wrap(el) { return el ? (el.closest('.shopify-section') || el) : null; }
  function cleanup() {
    document.querySelectorAll('[data-lu-spacer]').forEach(function (n) { n.remove(); });
    state.items.forEach(function (it) {
      ['position', 'top', 'left', 'right', 'width', 'z-index'].forEach(function (p) { it.w.style.removeProperty(p); });
    });
    state.items = [];
    if (state.ro) { state.ro.disconnect(); state.ro = null; }
  }
  function layout() {
    var top = 0;
    state.items.forEach(function (it) {
      it.w.style.setProperty('top', top + 'px', 'important');
      top += it.w.getBoundingClientRect().height;
    });
    document.documentElement.style.setProperty('--lu-ann-h', (state.items[0] && state.items[0].kind === 'ann' ? Math.round(state.items[0].w.getBoundingClientRect().height) : 0) + 'px');
    state.items.forEach(function (it) { it.sp.style.height = Math.round(it.w.getBoundingClientRect().height) + 'px'; });
  }
  function stuck() {
    var hdr = document.querySelector('[data-lu-freeze="hdr"]');
    if (!hdr) return;
    if ((window.pageYOffset || document.documentElement.scrollTop) > 24) hdr.setAttribute('data-stuck', ''); else hdr.removeAttribute('data-stuck');
  }
  function init() {
    cleanup();
    var list = [['ann', document.querySelector('[data-lu-freeze="ann"]')], ['hdr', document.querySelector('[data-lu-freeze="hdr"]')]];
    list.forEach(function (pair, i) {
      var w = wrap(pair[1]);
      if (!w) return;
      var sp = document.createElement('div');
      sp.setAttribute('data-lu-spacer', ''); sp.style.cssText = 'display:block;pointer-events:none;visibility:hidden;margin:0;padding:0;border:0';
      w.parentNode.insertBefore(sp, w);
      w.style.setProperty('position', 'fixed', 'important');
      w.style.setProperty('left', '0', 'important');
      w.style.setProperty('right', '0', 'important');
      w.style.setProperty('width', '100%', 'important');
      w.style.setProperty('z-index', pair[0] === 'ann' ? '61' : '60', 'important');
      state.items.push({ kind: pair[0], w: w, sp: sp, h: 0 });
    });
    if (!state.items.length) return;
    layout(); stuck();
    if (window.ResizeObserver) { state.ro = new ResizeObserver(layout); state.items.forEach(function (it) { state.ro.observe(it.w); }); }
  }
  var inited = false;
  function boot() { init(); if (!inited) { inited = true; window.addEventListener('scroll', stuck, { passive: true }); window.addEventListener('resize', layout); window.addEventListener('load', layout); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
  document.addEventListener('shopify:section:unload', function () { setTimeout(init, 50); });
})();
